import { ComponentIdSpan } from '@inter-ikea-core/core';

/**
 * The ID:s of the components specific to the SKYTTA range.
 */

// biome-ignore lint/complexity/noStaticOnlyClass: <fixme?>
export class SkyttaComponentIds {
  public static readonly ViewerRoomComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID;
  public static readonly RailAttachmentPointComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 1;
  public static readonly SlidingDoorFrameComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 2;
  public static readonly PanelComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 3;
  public static readonly SkyttaSizeComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 4;
  public static readonly RailTrackComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 5;
  public static readonly RailComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 6;
  public static readonly ScaledProductComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 7;
  public static readonly CeilingHeightReducerFrameComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 8;
  public static readonly StopBarComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 9;
  public static readonly UserSelectionComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 10;
  public static readonly RailTrackTypeOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 11;
  public static readonly DoorHeightOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 12;
  public static readonly PanelStyleOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 13;
  public static readonly DoorFrameColorOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 14;
  public static readonly CeilingHeightReducerOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 15;
  public static readonly StopBarOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 16;
  public static readonly RoomDimensionOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 17;
  public static readonly DoorLayoutOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 18;
  public static readonly AnimationComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 19;
  public static readonly PreferredDoorHeightOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 20;
  public static readonly CustomOutlineComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 21;
  public static readonly StorageBehindComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 22;
  public static readonly RoomTypeOptionsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 23;
  public static readonly PanelPatternsComponentId = ComponentIdSpan.SKYTTA_PLANNER_BASE_ID + 24;
}
